// Le SDK PayPal (et ses cookies) n'est chargé que sur la page Portefeuille,
// au moment où l'on veut payer — pas sur tout le site (RGPD / cookies).
let loading = null;

export const loadPaypal = () => {
  if (window.paypal) return Promise.resolve(window.paypal);
  const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
  if (!clientId) return Promise.reject(new Error("PayPal non configuré"));
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = `https://www.paypal.com/sdk/js?client-id=${encodeURIComponent(clientId)}&currency=EUR`;
      s.async = true;
      s.onload = () => (window.paypal ? resolve(window.paypal) : reject(new Error("PayPal indisponible")));
      s.onerror = () => {
        loading = null;
        reject(new Error("PayPal indisponible"));
      };
      document.body.appendChild(s);
    });
  }
  return loading;
};
